export enum AuthErrors {
    LoginRequired = 'login_required',
    InvalidGrant = 'invalid_grant',
    MissingRefreshToken = 'missing_refresh_token'
}
